// @ts-expect-error unmanaged is only referenced inside a parameter decorator, which TS doesn't treat as a real reference under standard decorators
import { injectable, unmanaged } from 'inversify';
import { Id } from '@shared/types/common';

@injectable()
export default class BaseService {
  protected urlPrefix: string;

  constructor(
    // @ts-expect-error parameter decorators require experimentalDecorators, which conflicts with mobx's standard decorators
    @(unmanaged() as ParameterDecorator)
    { domainArea }: { domainArea: string },
  ) {
    this.urlPrefix = `/${domainArea}`;
  }

  getURL(path: Id): string {
    return `${this.urlPrefix}/${path}`;
  }
}
